import {Component, Input, ChangeDetectionStrategy, inject} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {ErrorReferenceService, HTTPCONSTANTS} from "@odin/odin-core";
import {CognitoService} from "@odin/odin-authentication";
import {SignInSession} from "../../models/SignInSession";
import {Router} from "@angular/router";
import LoginResponse from "../../models/login-request";

@Component({
  selector: 'odin-mfa-auth-step',
  standalone: false,
  templateUrl: './mfa-auth-step.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './mfa-auth-step.component.css'
})
export class MfaAuthStepComponent {

  @Input() public mfaConfig: LoginResponse;
  public loading: boolean;
  public code: string;
  public errorMessage = '';
  private errorReference = inject(ErrorReferenceService);

  constructor(private httpClient: HttpClient, private cognitoService: CognitoService, private router: Router) {
    this.loading = false;
    this.code = '';
  }

  public Submit(): void {
    if (this.code === '') return;
    this.errorMessage = '';
    this.loading = true;

    this.httpClient.post<LoginResponse>(
      `${HTTPCONSTANTS.protocol}${HTTPCONSTANTS.baseAddress}/portal/odin-authentication/complete-mfa`,
      {
        email: this.mfaConfig.email,
        code: this.code,
        challengeName: this.mfaConfig.challengeName?.value,
        session: this.mfaConfig.session
      }).subscribe((res: LoginResponse) => {
        this.cognitoService.associateToken(new SignInSession().FromLoginResponse(res), (success: boolean) => {
          if (success) {
            this.cognitoService.CompleteLogin();
            setTimeout(() => {
              this.router.navigate(['/dashboard']).then(() => {
                this.loading = false;
              });
            }, 200)
          } else {
            this.cognitoService.loginChanged.emit(false);
            this.loading = false;
            const message = 'Unable to complete login, please try again.';
            this.errorMessage = this.errorReference.formatMessage(message, this.cognitoService.lastProfileError ?? new Error(message));
          }
        });
    }, (err: unknown) => {
      this.cognitoService.loginChanged.emit(false);
        this.loading = false;
        this.errorMessage = this.errorReference.formatMessage('Something went wrong, please try again.', err);
    });
  }
}
